import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { VscSettings } from "react-icons/vsc";

import { startLogout } from '../../store/asyncMethods/authMethods';
import { useQueryClient } from '@tanstack/react-query';


export const Navbar = () => {

    const queryClient = useQueryClient()

    const dispatch = useDispatch();
    const { email, profile } = useSelector(state => state.auth);


    const handleLogout = () => {
        dispatch(startLogout())
        queryClient.clear()
    }

    const checkedBtn = () => {
        document.getElementById("menu").checked = false
    }

    return (

        <nav className="navbar">
            <div className="navbar__container">
                <Link to="/" className="navbar__logo">
                    <img src="/assets/img/qc-logo.png" alt="logo" />
                </Link>

                <div className="navbar__menu">

                    <label htmlFor="menu" className="lines-icon">
                        <img src="/assets/img/menu-icon.svg" alt="menu-icon" />
                    </label>
                    <input type="checkbox" name="menu" id="menu" />
                    <ul className="navbar__list" name="navbarbar">
                        
                        <label htmlFor="menu" className="close-icon">
                            <img src="/assets/img/close-icon.svg" alt="close-icon" />
                            <input type="checkbox" name="menu" id="menu" />
                        </label>
                        <li className="navbar__profile mb-05" onClick={checkedBtn} >
                            <Link to="/user" className='profile-img'>
                                <img src={profile} alt="nav-report" />
                            </Link>
                        </li>
                        <li className="navbar__item" onClick={checkedBtn} ><Link to="/user">Edit Profile</Link></li>
                        <p className="navbar__email mb-2 mt-02">{email}</p>
                        <li className="navbar__item mb-05" onClick={checkedBtn} ><Link to="/suppliers">Suppliers</Link></li>
                        <li className="navbar__item mb-05" onClick={checkedBtn} ><Link to="/">All Reports</Link></li>
                        <li className="navbar__item mb-05" onClick={checkedBtn} ><Link to="/intakes">Intakes</Link></li>
                        <li className="navbar__item mb-05" onClick={checkedBtn} ><Link to="/new">New Report</Link></li>
                        <li className="navbar__item mb-05" onClick={checkedBtn} ><Link to="/life">Shelf Life Test</Link></li>
                        <li className="navbar__item mb-05" onClick={checkedBtn} ><Link to="/history">History</Link></li>
                        <li className="navbar__item mb-05" onClick={checkedBtn} ><Link to="/settings" className="tw-flex tw-items-center tw-gap-1">
                        <VscSettings />
                        Settings</Link></li>
                        <button
                            onClick={handleLogout}
                            className="btn-primary outline-2 mt-2">Logout
                        </button>
                    </ul>

                </div>
            </div>
        </nav>
    )
}
